import { axios } from "@/utils/request";

// 获取个性化设置
export function getWebConfig(params = {}) {
  return axios({
    url: "/welcome/publish/admin/login/getWebConfig",
    method: "get",
    params: params,
  });
}

// 登录
export function userLogin(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/login",
    method: "post",
    data: params,
  });
}
// 获取二维码地址
export function getQriously(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/showSchoolUrlByTypeAndUvCode",
    method: "get",
    params,
  });
}

// 注册
export function stuRegister(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/stuRegister",
    method: "post",
    data: params,
  });
}

// 注册--验证码
export function stuRegisterCode(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/getSmsCaptchaLoginTest",
    method: "post",
    data: params,
  });
}

// 注册--密码规则
export function registerPwdRule(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/getPwdRule",
    method: "post",
    data: params,
  });
}

// 获取个人信息
export function getUserInfo(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/baseinfo/realm",
    method: "get",
    params: params,
  });
}

// 退出登录
export function logOut(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/logout",
    method: "get",
    params: params,
  });
}

// 找回密码
export function forgotPwd(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/resetPwd/reset",
    method: "post",
    data: params,
  });
}

// 找回密码--密码规则
export function forgotPwdRule(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/getPwdRuleByPhone",
    method: "get",
    params: params,
  });
}

// 找回密码--验证码
export function forgotCode(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/forgotPwdVerification",
    method: "get",
    params: params,
  });
}

// 修改密码
export function updatePwd(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/updatePwd",
    method: "post",
    data: params,
  });
}

// 修改密码--密码规则
export function updatePwdRule(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/getInPwdRule",
    method: "get",
    params: params,
  });
}

// 修改账号
export function updateAccount(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/updateAccount",
    method: "post",
    data: params,
  });
}

// 修改账号--验证码
export function updateAccountCode(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/loginVerification",
    method: "get",
    params: params,
  });
}

// 获取账号修改次数
export function getAccountNum(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/getAccountNum",
    method: "get",
    params: params,
  });
}

// 获取当前账号
export function getCurAccount(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/getAccountInfo",
    method: "get",
    params: params,
  });
}
export function getAIUrl(params = {}) {
  return axios({
    url: "/welcome/publish/school/param/getParam",
    method: "get",
    params: params,
  });
}
